import { Modal } from 'react-bootstrap';

import utils from '../../utils';
import Button from '../generic/Button';
import { DOCS_URL, DocsLink, Link, SupportLink } from '../generic/Link';
import type { ProjectDashboardProject, ProjectDashboardRevision } from '../projects/projectDashboardTypes';

type IModalNoDependenciesFoundProps = {
  show: boolean;
  onHide: () => void;
  languageDocs: object;
  revision: ProjectDashboardRevision;
  project: ProjectDashboardProject;
};

const ModalNoDependenciesFound = ({
  revision,
  project,
  languageDocs,
  show,
  onHide,
}: IModalNoDependenciesFoundProps) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <h3 style={{ fontSize: '20px', marginLeft: '20px' }}>
        <b>
          No Dependencies Found
        </b>
      </h3>
    </Modal.Header>
    <Modal.Body style={{ margin: '10px 20px' }}>
      <p>FOSSA could not find any dependencies in this repo. This may happen for a number of reasons:</p>
      <ol className="subtitle">
        <li>
          Make sure FOSSA supports your environment and package managers{' '}
          <DocsLink to="supported-languages">
            <b>(view list here)</b>
          </DocsLink>
        </li>
        <li>
          Make sure you&apos;ve configured any authentication or private registries to work with FOSSA -- {revision.data.source_type && languageDocs[revision.data.source_type] ? (
            <span>
              Visit the{' '}
              <b>
                <u>
                  <DocsLink to={languageDocs[revision.data.source_type].slug}>
                    Configuration Guide for {languageDocs[revision.data.source_type].name} projects
                  </DocsLink>
                </u>
              </b>
            </span>
        ) : (
          <span>
            Visit the{' '}
            <b>
              <Link to={DOCS_URL} openInNewTab>
                Docs
              </Link>
            </b>{' '}
            or{' '}
            <b>
              <Link to={`/projects/${utils.nuc(project.data.locator)}/settings`}>
                Settings
              </Link>
            </b>{' '}
            for configuration guidelines
          </span>
        )}
        </li>
        <li>
          Manually{' '}
          <a className="clickable">
            <b>Add a Dependency</b>
          </a>
        </li>
        <li>
          <SupportLink>
            <b>Contact Support</b>
          </SupportLink>
        </li>
      </ol>
    </Modal.Body>
    <Modal.Footer style={{ background: '#fafafa', borderRadius: '0px 0px 4px 4px' }}>
      <Button
        type="primary"
        size="medium"
        onClick={onHide}
      >
        Got It!
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalNoDependenciesFound;
